<template>
  <header class="app-header">
    <div class="top-bar">
      <div class="grid-x grid-padding-x align-middle">
        <div class="top-bar__app-icon cell shrink">
          <a href="/">
            <img v-if="$store.state.portalSettings.vendor_portal_logo_url"
                 :src="$store.state.portalSettings.vendor_portal_logo_url"
                 alt="">
            <h1 v-if="!$store.state.portalSettings.vendor_portal_logo_url"
                style="margin: 0;">{{ $store.state.portalSettings.name }}</h1>
          </a>
        </div>

        <div id="main-menu" class="cell auto large-shrink show-for-large">
          <ul class="top-bar__menu">
            <!--            <li><router-link :to="{ name: 'home'}"-->
            <!--                             :class="[this.$route.name === 'home' ? 'active' : '']">Dashboard</router-link>-->
            <!--            </li>-->
            <li v-if="$store.state.portalSettings.myshopify_domain !== 'qualityfood.myshopify.com' && $store.state.portalSettings.myshopify_domain !== 'localview.myshopify.com'"><router-link :to="{ name: 'commissionsList' }"
                                                                                                                 :class="[this.$route.name === 'commissionsList' ? 'active' : '']">Commissions</router-link>
            </li>
            <li v-if="$store.state.portalSettings.myshopify_domain === 'waxpackcity.myshopify.com'">
              <router-link :to="{ name: 'unpaidList'}" :class="[this.$route.name === 'unpaidList' ? 'active' : '']">Unpaid Orders</router-link>
            </li>
            <li v-if="$store.state.metas.vendor_portal_products.meta_value !== false"><router-link :to="{ name: 'productsList'}"
                                                                                                   :class="[this.$route.name === 'productsList' || this.$route.name === 'productsSingle' ? 'active' : '']">Products</router-link>
            </li>
            <li v-if="$store.state.portalSettings.myshopify_domain !== 'qualityfood.myshopify.com' && $store.state.portalSettings.myshopify_domain !== 'localview.myshopify.com'"><router-link :to="{ name: 'payoutsList' }" v-if="$store.state.portalSettings.myshopify_domain != 'the-makers-mark.myshopify.com' && $store.state.portalSettings.myshopify_domain != 'inuitbookshop.myshopify.com'"
                                                                                                                 :class="[this.$route.name === 'payoutsList' ? 'active' : '' || this.$route.name === 'payoutsSingle' ? 'active' : '']">Payouts</router-link>
            </li>
            <li v-if="$store.state.portalSettings.myshopify_domain == 'physicians-longevity.myshopify.com' || $store.state.portalSettings.myshopify_domain == 'visceral-apps-staging.myshopify.com'">
              <router-link :to="{ name: 'customers' }"
                           :class="[this.$route.name === 'customers' ? 'active' : '' || this.$route.name === 'customers' ? 'active' : '']">Customers</router-link>
            </li>
            <li v-if="$store.state.portalSettings.myshopify_domain == 'youfromme.myshopify.com' || $store.state.portalSettings.myshopify_domain == 'visceral-apps-staging.myshopify.com'">
              <router-link :to="{ name: 'sellerRegistration' }"
                           :class="[this.$route.name === 'sellerRegistration' ? 'active' : '' || this.$route.name === 'sellerRegistration' ? 'active' : '']">Sell Form</router-link>
            </li>
            <li><a @click="logout">Logout <i class="fa-sign-out fas"></i></a></li>
          </ul>
        </div>

        <div class="cell auto text-right">
          <ul class="top-bar__menu top-bar__menu--icons"
              style="border-right: 1px solid #333333; display: inline-block; margin-right: 25px; padding-right: 15px;" v-if="loadLinks">
            <li class="boxed" style="position: relative;" v-if="$store.state.vendors !== null && $store.state.vendors.length > 1">
              <a @click="openVendorMenu">
                {{ $store.state.vendors[$store.state.currentVendor].name }}
                <i class="fa-caret-down fas"></i>
              </a>

              <div class="vendor-selection" v-if="vendorMenuOpen">
                <div class="vendor-selection__vendor"
                     v-for="(vendor, key) in $store.state.vendors"
                     :key="key" @click="switchVendor(vendor.id)">{{ vendor.name }}</div>
              </div>
            </li>
            <li><router-link :to="{ name: 'settings' }"
                             :class="[this.$route.name === 'settings' ? 'active' : '']">
              <i class="fa-cog fas"></i></router-link></li>
            <!--            <li><router-link :to="{ name: 'helpDashboard' }"-->
            <!--                             :class="[this.$route.name === 'helpDashboard' ? 'active' : '']"><i-->
            <!--              class="fa-question-circle fas"></i></router-link></li>-->
          </ul>

          <ul class="top-bar__menu top-bar__menu--icons" style="display: inline-block;">
            <li class="hide-for-large">
              <a @click="openMenu"><i class="fa-bars fas"></i></a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="page-actions__wrapper">
      <div class="page-actions">
        <div class="grid-container">
        </div>
      </div>
    </div>

    <div id="flash-message" class="flash-message" v-if="message">
      <div class="grid-x grid-padding-x">
        <div class="cell">
          <div class="callout alert">
            <p></p>
          </div>

          <div class="callout success">
            <p></p>
          </div>
        </div>
      </div>
    </div>

    <transition name="slide-fade">
      <progressBar v-if="syncing"></progressBar>
    </transition>
  </header>
</template>

<script>
import client from '@/mixins/client'
import progressBar from '@/globals/progressBar'
import env from '@/mixins/env'

export default {
  mixins: [client],
  props: [
    'loadLinks'
  ],
  components: {
    progressBar
  },
  data: function () {
    return {
      params: '/?' + env.params(),
      syncing: false,
      message: false,
      iframe: true,
      menuOpen: false,
      vendorMenuOpen: false
    }
  },
  methods: {
    sync () {
      this.syncing = true
    },
    openVendorMenu () {
      this.vendorMenuOpen = !this.vendorMenuOpen
    },
    switchVendor (id) {
      for (let i = 0; i < this.$store.state.vendors.length; i++) {
        if (this.$store.state.vendors[i].id === id) {
          this.$store.state.currentVendor = i
          this.vendorMenuOpen = false

          this.$router.push('/apps/vendor-portal/reload/')
        }
      }
    },
    openMenu () {
      let menu = document.getElementById('main-menu')

      if (this.menuOpen) {
        menu.className = 'cell auto show-for-medium'
      } else {
        menu.className = 'cell auto open show-for-medium'
      }

      this.menuOpen = !this.menuOpen
    },
    logout () {
      this.request('get', '/vendors/logout/?' + env.params()).catch(() => {
        // Server logout failed (e.g. expired session token) — continue with client-side cleanup
      }).finally(() => {
        this.$store.state.vendors = null
        this.$store.state.token = null
        this.$store.state.refreshToken = null
        this.$store.state.shop = null
        this.$store.state.settings = null
        this.$store.state.appSettings = null
        this.$store.state.metas = null
        this.$store.state.paypal = null
        this.$store.state.syncing = null

        window.$cookies.remove('va-token')
        window.$cookies.remove('va-refresh-token')

        this.$router.go('/apps/vendor-portal/login')
      })
    }
  },
  watch: {
    $route (to, from) {
      let menu = document.getElementById('main-menu')

      menu.className = 'cell auto show-for-large'

      this.menuOpen = false
    }
  },
  computed: {
    metas () {
      return this.$store.state.metas
    }
  },
  created () {
    // console.log(this.$store.state.metas.vendor_portal_products)
    function inIframe () {
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    }

    if (!inIframe()) {
      this.iframe = false
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'qualityfood.myshopify.com' && this.$store.state.portalSettings.myshopify_domain !== 'localview.myshopify.com' && (this.$route.name === 'commissionsList' || this.$route.name === 'payoutsList')) {
      this.$router.push('/apps/vendor-portal/products')
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/mixins';
@import '../../styles/variables';

.app-header {
  padding-top: 56px;
  margin-bottom: 15px;
}

.vendor-selection {
  background: $darkest-gray;
  border: 1px solid $darker-gray;
  border-radius: 5px 0 5px 5px;
  overflow: hidden;
  position: absolute;
  right: 0;
  text-align: left;
  top: calc(100% - 5px);
  white-space: nowrap;
  z-index: 9;

  &__vendor {
    background: $darkest-gray;
    border-bottom: 1px solid $darker2-gray;
    color: $white;
    cursor: pointer;
    padding: 10px 20px;

    &:hover {
      background: darken($darkest-gray, 5%);
    }

    &:last-child {
      border: 0;
    }
  }
}

.top-bar {
  background: #222222;
  border-bottom: 1px solid var(--secondary-color);
  left: 0;
  padding: 6px 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9;

  &__app-icon {
    text-align: center;

    img {
      height: 30px;
    }
  }

  &__title {
    color: $white;
    display: inline-block;
    line-height: 1;
    margin-bottom: 0;
  }

  &__menu {
    margin: 0 0 0 -15px;

    li {
      display: inline-block;

      &.boxed {
        a {
          border: 1px solid $dark-gray;
          border-radius: 5px;

          svg {
            margin-left: 10px;
          }
        }
      }
    }

    a {
      @include transition(background .25s);
      border-radius: 5px;
      display: inline-block;
      color: $white;
      padding: 6px 15px;

      &:hover {
        background: $darkest-gray;
        color: $white;
      }

      &.active {
        background: var(--secondary-color);
      }
    }

    &--icons {
      a {
        @include transition(color .25s);
        padding: 6px 10px;
      }
    }
  }
}

.light-theme {
  .top-bar {
    background: #fafafa;

    &__menu {
      li {
        &.boxed {
          a {
            border: 1px solid $medium-gray;
          }
        }
      }

      a {
        color: $darkest-gray;

        &:hover {
          background: $light-gray;
        }

        &.active {
          background: var(--secondary-color);
          color: $white;
        }
      }

      &--icons {
        a {
          color: $darkest-gray;
        }
      }
    }
  }

  .vendor-selection {
    background: $white;
    border: 1px solid $light-gray;
    border-radius: 5px 0 5px 5px;
    overflow: hidden;
    position: absolute;
    right: 0;
    text-align: left;
    top: calc(100% - 5px);
    white-space: nowrap;
    z-index: 9;

    &__vendor {
      background: $white;
      border-bottom: 1px solid $light-gray;
      color: $black;
      cursor: pointer;
      padding: 10px 20px;

      &:hover {
        background: darken($darkest-gray, 5%);
      }

      &:last-child {
        border: 0;
      }
    }
  }
}

#main-menu.open {
  background: #222222;
  border-bottom: 1px solid var(--secondary-color);
  display: block !important;
  left: 0;
  position: absolute;
  right: 0;
  top: 100%;

  .top-bar {
    &__menu {
      margin: 0 -15px 0;

      li {
        display: block;
      }

      a {
        @include transition(background .25s);
        border-radius: 5px;
        display: block;
        color: $white;
        padding: 10px 15px;
        text-align: center;

        &:hover {
          background: $darkest-gray;
          color: $white;
        }

        &.active {
          background: var(--secondary-color);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/vendorPortalHeader.vue